<template>
  <div class="mb-4">
    <div
      class="bg-custom-light-green rounded-top d-lg-flex flex-row px-3 py-2 align-items-center bd-highlight"
    >
      <div class="d-flex flex-row w-80 bd-highlight">
        <div class="color-secondary-6 font-14 mr-1">
          Nombre del Estudiante:
        </div>
        <div class="font-weight-bold font-16">
          {{ item.student?.name | empty }} / {{ item.student?.id | empty }}
        </div>
      </div>
    </div>

    <custom-callout
      has-toggle
      controlled
      :opened="isOpen"
      :border-color="'#B5C3BC'"
      @click:open="onToggle()"
      class="border-radius-top-auto"
    >
      <div class="row m-0 d-flex align-items-center">
        <div class="col-12 mb-3 mb-lg-0 pl-md-0 py-3">
          <div class="row font-weight-normal">
            <div class="col-md-2 col-12">
              <div class="color-secondary-6 font-14">
                Impedimento:
              </div>
              <div class="color-black font-16">
                {{ item.impediment | empty }}
              </div>
            </div>

            <div class="col-md col-12">
              <div class="color-secondary-6 font-14">
                Grado:
              </div>
              <div class="color-black font-16">
                {{ item.grade | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12">
              <div class="color-secondary-6 font-14">
                Total de Libros Asignados:
              </div>
              <div class="color-black font-16">
                {{ item.totalAssignedBooks | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12">
              <div class="color-secondary-6 font-14">
                Total de Solicitudes en Proceso:
              </div>
              <div class="color-black font-16">
                {{ item.totalRequestInProgress | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12">
              <div class="color-secondary-6 font-14">
                Total de Solicitudes:
              </div>
              <div class="color-black font-16">
                {{ totalRequests | empty }}
              </div>
            </div>
            <div class="col-md-2 col-12">
              <drop-down
                always-show-dropdown
                :items="actionItems"
                class="float-md-right mt-2 mt-md-1"
              />
            </div>
          </div>
        </div>
      </div>
      <template #edition>
        <div v-if="isSeizeSectionVisible">
          <confiscate-book
            :book="item"
            @close="onClosePanel"
            @save="handlerConfiscate"
          />
        </div>
        <div v-if="isViewBooksActionVisible">
          <BooksAssignedToStudent :student="item.student"/>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import IconView from "icon-view";
import { CustomTab, CustomTabItem } from "custom-tabs";
import CustomCallout from "custom-callout";
import DropDown from "dropdown";
import CustomBalloon from "custom-balloon";
import ACTIONS from "@/utils/constants/inventoryBookRowActions";
import PROPERTIES from "@/utils/constants/inventory/bookItemProperties";
import ConfiscateBook from "./ConfiscateBook.vue";
import peiAtServiceEquipmentStatus from "@/utils/constants/inventory/peiAtServiceEquipmentStatus";
import inventoryCatalogService from "@/services/api/inventorycatalog.api";
import BooksAssignedToStudent from "./BooksAssignedToStudent.vue";

const TEMPLATE_TAB_INDEX = {
  BOOK: 0
};
const TEMPLATE_ACTION_INDEX = {
  INFO: 0,
  SEIZE: 1,
  BOOKSASSIGNED: 2
};
export default {
  name: "BookResultRow",
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon,
    CustomTab,
    CustomTabItem,
    IconView,
    ConfiscateBook,
    BooksAssignedToStudent,
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    },
    actionsToShow: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      selectedTemplateTabIndex: null,
      isOpen: false,
      activeTab: TEMPLATE_TAB_INDEX.BOOK,
      currentAction: null,
      actions: ACTIONS,
      book: {}
    };
  },
  computed: {
    totalRequests(){
      return this.item?.totalAssignedBooks + this.item?.totalRequestInProgress
    },
    actionItems() {
      const actions = [
        {
          id: ACTIONS.AssignStudent,
          action: {
            name: "Asignar Estudiante",
            icon: "fas fa-user-plus text-success",
            click: () => this.showBookInfo()
          }
        },
        {
          id: ACTIONS.UnassignStudent,
          action: {
            name: "Desasignar Estudiante",
            icon: "fas fa-user-minus text-danger",
            click: () => this.showBookInfo()
          }
        },
        {
          id: ACTIONS.CustodianHistory,
          action: {
            name: "Historial de Custodio",
            icon: "fas fa-history text-success",
            click: () => this.showBookInfo()
          }
        },
        {
          id: ACTIONS.Seize,
          action: {
            name: "Decomisar",
            icon: "fas fa-ban text-danger",
            visible: this.isSeizeButtonVisible,
            click: () => this.showSeizeForm()
          }
        },
        {
          id: ACTIONS.ViewAllBooksAssigned,
          action: {
            name: "Ver Libro Asignado",
            icon: "fas fa-file-search text-success",
            visible: true,
            click: () => this.showBooksAssigned()
          }
        }
      ];

      return actions
        .filter(x => this.actionsToShow.includes(x.id))
        .map(x => x.action);
    },
    readingMedium() {
      return this.item.properties?.find(
        x => x.name === PROPERTIES.ReadingMedium
      );
    },
    isSeizeButtonVisible() {
      return [
        peiAtServiceEquipmentStatus.Returned,
        peiAtServiceEquipmentStatus.AssignedToStudent,
        peiAtServiceEquipmentStatus.AssignedToTeacher
      ].includes(this.item?.statusId);
    },
    isSeizeSectionVisible() {
      return this.currentAction == TEMPLATE_ACTION_INDEX.SEIZE;
    },
    isViewBooksActionVisible() {
      return this.currentAction == TEMPLATE_ACTION_INDEX.BOOKSASSIGNED;
    }
  },
  methods: {
    onToggle() {
      this.selectedTemplateTabIndex = null;

      if (this.item.isOpen) {
        this.isOpen = false;
        this.$emit("close", this.item);
        return;
      }

      this.currentAction = TEMPLATE_ACTION_INDEX.BOOKSASSIGNED;
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.BOOK;
      this.isOpen = true;
      this.$emit("open", this.item);
    },
    setCurrentTab(tab) {
      this.activeTab = tab;
    },
    onClosePanel() {
      this.currentAction = null;
      this.onToggle();
    },
    showBookInfo() {
      this.currentAction = TEMPLATE_ACTION_INDEX.INFO;
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.BOOK;
      this.setCurrentTab(TEMPLATE_TAB_INDEX.BOOK);
      this.$emit("open", this.item);
    },
    showSeizeForm() {
      this.currentAction = TEMPLATE_ACTION_INDEX.SEIZE;
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.BOOK;
      this.isOpen = true;
      this.$emit("open", this.item);
    },
    showBooksAssigned() {
      this.currentAction = TEMPLATE_ACTION_INDEX.BOOKSASSIGNED;
      this.selectedTemplateTabIndex = TEMPLATE_TAB_INDEX.BOOK;
      this.isOpen = true;
      this.$emit("open", this.item);
    },
    async handlerConfiscate(model) {
      try {
        await inventoryCatalogService.consfiscateBook(model);
        this.onClosePanel();
        this.$emit("refresh");
        this.ShowToast(
          "Éxito",
          "El libro ha sido decomizado exitosamente.",
          "success"
        );
      } catch (error) {
        this.ShowToast("Error", error?.response?.data.message, "error");
      }
    }
  }
};
</script>
<style scoped lang="scss">
::v-deep .balloon-container.success {
  background-color: #a3e5b3;
}
::v-deep .balloon-container.warning {
  background-color: #f8b539;
}

.border-radius-top-auto ::v-deep .border-radius--light {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.bg-custom-light-green {
  background-color: #d9e5dfba;
}
.bg-custom-light-tracked {
  background-color: #f7f7f7;
}
.border-bottom-2 {
  border-bottom: 2px solid #dee2e6 !important;
}
</style>
